<template>
    <kgr-icon
        :icon-class="iconClass"
        :disabled="disabled"
        :accent="accent"
        :small="small"
        :big="big"
        :title="title"
        :highlight="highlight"
        :green-dot="greenDot"
        @click="$emit('click')"
    />
</template>

<script>
import Icon from './Icon';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        accent: {
            type: Boolean,
            required: false,
            default: false,
        },
        small: {
            type: Boolean,
            required: false,
            default: false,
        },
        big: {
            type: Boolean,
            required: false,
            default: false,
        },
        highlight: {
            type: Boolean,
            required: false,
            default: false,
        },
        greenDot: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            iconClass: '',
        };
    },
    mounted() {
        if (this.title === null) {
            return;
        }
        $(this.$el).tooltip({
            position: { my: 'left-26 top', at: 'left bottom+10', collision: 'none' },
        });
    },
    beforeUnmount() {
        if (this.title === null) {
            return;
        }
        const $element = $(this.$el);
        if ($element.data('ui-tooltip')) {
            $element.tooltip('destroy');
        }
    },
};
</script>
